import { render, staticRenderFns } from "./ModifyRole.vue?vue&type=template&id=ab0523c4&scoped=true"
import script from "./ModifyRole.vue?vue&type=script&lang=js"
export * from "./ModifyRole.vue?vue&type=script&lang=js"
import style0 from "./ModifyRole.vue?vue&type=style&index=0&id=ab0523c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0523c4",
  null
  
)

export default component.exports